import React from 'react'
import { Icon } from "@material-ui/core";
import N8nLogo from './n8n.io_.svg'

export const N8nIcon = () => (
    React.createElement(Icon, null
        , React.createElement('img', { src: N8nLogo, alt: "", height: 25, width: 25,})
    )
)